import { __decorate } from "tslib";
import React from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import scrollIntoView from 'scroll-into-view-if-needed';
import ObserverCheckBox from '../check-box/CheckBox';
import { $l } from '../locale-context';
import ObserverTextField from '../text-field/TextField';
import Icon from '../icon';
import { DISABLED_FIELD, getItemKey, Select } from '../select/Select';
import autobind from '../_util/autobind';
import { stopPropagation } from '../_util/EventManager';
import ViewComponent from '../core/ViewComponent';
import CustomArea from './CustomArea';
let TransferList = class TransferList extends Select {
    constructor() {
        super(...arguments);
        this.wrapperRef = null;
        this.handleRemove = (value) => {
            const { onRemove } = this.props;
            if (onRemove) {
                onRemove(value);
            }
        };
    }
    get popup() {
        return true;
    }
    get header() {
        const { prefixCls, multiple, observableProps: { header }, } = this;
        if (multiple || header) {
            return (React.createElement("div", { className: `${prefixCls}-header` },
                this.getHeaderSelected(),
                header && React.createElement("span", { className: `${prefixCls}-header-title` }, header)));
        }
        return undefined;
    }
    get footer() {
        const { prefixCls, filteredOptions, observableProps: { footer }, } = this;
        if (footer) {
            return React.createElement("div", { className: `${prefixCls}-footer` }, footer(filteredOptions));
        }
        return undefined;
    }
    componentDidUpdate() {
        const { currentIndex } = this.props;
        // 在渲染完之后执行
        if (this.wrapperRef && typeof currentIndex !== 'undefined') {
            const contentDom = this.wrapperRef.getElementsByTagName('ul')[0];
            const findSelectedDom = this.wrapperRef.getElementsByTagName('li');
            if (contentDom && currentIndex && currentIndex > -1 && currentIndex < this.filteredOptions.length) {
                const selectedDom = findSelectedDom[currentIndex];
                scrollIntoView(selectedDom, { block: 'end', behavior: 'smooth', scrollMode: 'if-needed', boundary: contentDom });
            }
            this.options.setState('targetFilteredOptions', this.filteredOptions);
        }
    }
    getOmitPropsKeys() {
        return super
            .getOmitPropsKeys()
            .concat(['autoComplete', 'footer', 'header', 'selected', 'onSelect', 'onSelectAll']);
    }
    getOtherProps() {
        const otherProps = super.getOtherProps();
        delete otherProps.ref;
        delete otherProps.type;
        delete otherProps.onChange;
        delete otherProps.onKeyDown;
        delete otherProps.currentIndex;
        delete otherProps.sortable;
        delete otherProps.sortOperations;
        delete otherProps.oneWay;
        delete otherProps.onRemove;
        delete otherProps.targetOption;
        delete otherProps.direction;
        return otherProps;
    }
    getObservableProps(props, context) {
        return {
            ...super.getObservableProps(props, context),
            header: props.header,
            footer: props.footer,
        };
    }
    getMenuPrefixCls() {
        return `${this.prefixCls}-content`;
    }
    handleSelectAllChange(value) {
        const { onSelectAll } = this.props;
        if (onSelectAll) {
            onSelectAll(value ? this.filteredOptions.filter(record => !record.get(DISABLED_FIELD)) : []);
        }
    }
    handleClear() {
        this.setText(undefined);
    }
    getHeaderSelected() {
        const { filteredOptions: { length }, multiple, prefixCls, props: { selected: { length: selectedLength }, }, } = this;
        const selectedText = selectedLength ? `${selectedLength}/` : '';
        const disabledLength = this.filteredOptions.filter(record => record.get(DISABLED_FIELD)).length;
        if (multiple) {
            return (React.createElement(ObserverCheckBox, { disabled: this.disabled, onChange: this.handleSelectAllChange, onFocus: stopPropagation, checked: !!length && disabledLength !== length && (length === selectedLength || length - disabledLength === selectedLength), indeterminate: !!selectedLength && (length - disabledLength !== selectedLength) },
                React.createElement("span", { className: `${prefixCls}-header-selected` }, `${selectedText}${length}${$l('Transfer', 'items')}`)));
        }
        return (React.createElement("span", { className: `${prefixCls}-header-selected` }, `${length}${$l('Transfer', 'items')}`));
    }
    getSearchField() {
        const { prefixCls } = this;
        return (React.createElement("div", { className: `${prefixCls}-body-search-wrapper` },
            React.createElement(ObserverTextField, { ref: this.elementReference, onInput: this.handleChange, onClear: this.handleClear, onKeyDown: this.handleKeyDown, prefix: React.createElement(Icon, { type: "search" }), clearButton: true })));
    }
    getMenuItem({ record, text, value }) {
        const { prefixCls, multiple, options, props: { oneWay, optionRenderer }, } = this;
        if (oneWay && !multiple) {
            const renderer = (React.createElement("div", { className: `${prefixCls}-item-delete` },
                React.createElement("div", null, text),
                React.createElement(Icon, { type: "delete_black-o", className: `${prefixCls}-item-icon`, onClick: () => this.handleRemove(value) })));
            return optionRenderer
                ? optionRenderer({ dataSet: options, record, text, value })
                : renderer;
        }
        return super.getMenuItem({ record, text, value });
    }
    renderBody() {
        const { prefixCls, searchable, textField, valueField, multiple, props: { selected, onSelect, onSelectAll, setTargetOption, children, targetOption, direction }, } = this;
        const searchField = searchable && this.getSearchField();
        const classString = classNames(`${prefixCls}-body`, {
            [`${prefixCls}-body-with-search`]: searchable,
        });
        // 自定义渲染
        if (typeof children === 'function') {
            return (React.createElement(CustomArea, { targetOption: targetOption }, children({ direction, targetOption, setTargetOption, onItemSelect: onSelectAll })));
        }
        const selectedKeys = multiple ? selected.map(record => getItemKey(record, record.get(textField), record.get(valueField))) : [];
        return (React.createElement("div", { className: classString },
            searchField,
            React.createElement("div", { className: `${prefixCls}-content-wrapper`, ref: dom => {
                    this.wrapperRef = dom;
                }, onFocus: searchable ? stopPropagation : undefined }, this.getMenu({ selectedKeys, onClick: onSelect, focusable: !this.searchable }))));
    }
    getClassName() {
        const { prefixCls, header, footer } = this;
        return super.getClassName({
            [`${prefixCls}-with-header`]: header,
            [`${prefixCls}-with-footer`]: footer,
        });
    }
    removeLastValue() {
        // noop
    }
    handleBlur(e) {
        ViewComponent.prototype.handleBlur.call(this, e);
    }
    renderHelpMessage() {
        return null;
    }
    renderWrapper() {
        const { header, footer, props: { style, children } } = this;
        const isCustom = typeof children === 'function';
        return (React.createElement("div", Object.assign({}, this.getOtherProps(), { style: style }),
            !isCustom && header,
            this.renderBody(),
            !isCustom && footer));
    }
};
__decorate([
    computed
], TransferList.prototype, "header", null);
__decorate([
    computed
], TransferList.prototype, "footer", null);
__decorate([
    autobind
], TransferList.prototype, "handleSelectAllChange", null);
__decorate([
    autobind
], TransferList.prototype, "handleClear", null);
__decorate([
    autobind
], TransferList.prototype, "handleBlur", null);
TransferList = __decorate([
    observer
], TransferList);
export default TransferList;
